import * as priority from 'priority-web-sdk';
import {Configuration, ProcType, ProcData} from 'priority-web-sdk';
import {API_BASE_URL} from '../proto/core/server';
import {getTabulaIni, getUserLogin, getUserPassword} from '../../constants/metaData';
import {getLang} from '../../Localization';
import {getCompanyName} from '../../utils/proto-api-utils/utils';
import {appName, isOpenidLogin} from '../proto/core/loginProps';
import {getKey} from '../wasm/apiService';
import {getWcfLogin} from '../../_shared/GWTBridge/invoke/genPage';
import {noop} from '@priority-software/priority-style-react/dist';

const getLoginConfig: () => Configuration = () => ({
    url: API_BASE_URL,
    tabulaini: getTabulaIni(),
    language: Number(getLang()),
    profile: {company: getCompanyName()},
    username: isOpenidLogin() ? getWcfLogin() : getUserLogin(),
    password: getUserPassword(),
    appid: appName,
    appname: appName,
    appkey: getKey(),
    devicename: ''
});

const userLogin = async () => {
    try {
        await priority.login(getLoginConfig());
    } catch (e) {
        throw Error(e as string);
    }
};

export const startProcedure = async (
    procName: string,
    type: ProcType,
    dname?: string
): Promise<ProcData> => {
    try {
        await userLogin();
        return await priority.procStart(procName, type, noop, dname || getCompanyName());
    } catch (e) {
        throw Error(e as string);
    }
};
